export const ZOOM_DEFAULT = {
  MAX_ZOOM: 3,
  MIN_ZOOM: 1,
  DEFAULT_ZOOM: 1,
  INITIAL_ZOOM: 1.3, // default cropped area 70%
  ZOOM_STEP: 0.1,
  ASPECT_RATIO: 16 / 9,
};
